// body load
$(window).load(function() {
	$('body').animate({ opacity:1 },100);	
});

$(document).ready(function(){
  
  
  $(".Color_bg").html(function() {
    return $(this).html().replace("Color: DarkBrown", "Color: Dark Brown");
  });
  
  $(".Color_bg").html(function() {
    return $(this).html().replace("Color: LightGreen", "Color: Light Green");
  });
  
  $(".Color_bg").html(function() {
    return $(this).html().replace("Color: DarkGrey", "Color: Dark Grey");
  });
  
  $(".Color_bg").html(function() {
    return $(this).html().replace("Color: MidBrown", "Color: Mid Brown");
  });
  
  $(".Color_bg").html(function() {
    return $(this).html().replace("Color: WhiteTan", "Color: White Tan");
  });
  
  $(".Color_bg").html(function() {
    return $(this).html().replace("Color: DarkBlue", "Color: Dark Blue");
  });
  
  $(".Color_bg").html(function() {
    return $(this).html().replace("Color: LightBrown", "Color: Light Brown");
  });
  
  
  $(".Color_bg").html(function() {
    return $(this).html().replace("Color: PretoBlack", "Color: Preto Black");
  });
  
  $(".Color_bg").html(function() {
    return $(this).html().replace("Color: SilverBrown", "Color: Silver Brown");
  });
  
  
  $(".list-menu h3").click(function(){
      $(".list-menu ul").slideToggle('slow');
      $(this).toggleClass('active_h3');
  });
  
  $(".footer_search").click(function(){
      $(".search_bg").toggle();
      $("#SearchDrawer").toggleClass('active_search');
      $('body').toggleClass('no-scroll');
      $(".footer_new_link").hide(); 
      $(".footer_search").toggleClass('active_nav_footer');	
      $(".shoes_icon").removeClass('active_nav_footer');			
  });
  
  $(".shoes_icon").click(function(){
      $(".search_bg").hide();
      $(".footer_new_link").toggle(); 	
      $("#SearchDrawer").removeClass('active_search');
      $('body').toggleClass('no-scroll');
      $(".footer_search").removeClass('active_nav_footer');		
      $(".shoes_icon").toggleClass('active_nav_footer');	
  });
   
  
  
   
  if($(window).width() < 767){
    
    $(".list-menu ul li a").click(function(){
     $(".list-menu ul").slideUp('slow');
      $(".list-menu h3").removeClass('active_h3');
  });
    
   // $(".thum_ul").addClass('thum_ul_mobile');
  //  $(".product-single__thumbnails-item div").removeClass('zoom_img');
    
  }
  
  
  $('#filter-1 .label_title').click(function(){
    $("#filter-1 ul").slideToggle();
    $("#filter-2 ul").slideUp();
    $("#filter-3 ul").slideUp();
    $("#filter-4 ul").slideUp();
    $("#filter-5 ul").slideUp();
    $(this).toggleClass('on');
    $("#filter-2 .label_title").removeClass('on');
    $("#filter-3 .label_title").removeClass('on');
    $("#filter-4 .label_title").removeClass('on');
    $("#filter-5 .label_title").removeClass('on');	
  });
  
  $('#filter-2 .label_title').click(function(){
    $("#filter-2 ul").slideToggle();
    $("#filter-1 ul").slideUp();
    $("#filter-3 ul").slideUp();
    $("#filter-4 ul").slideUp();
    $("#filter-5 ul").slideUp();
    $(this).toggleClass('on');
    $("#filter-2 .label_title").removeClass('on');
    $("#filter-3 .label_title").removeClass('on');
    $("#filter-4 .label_title").removeClass('on');
    $("#filter-5 .label_title").removeClass('on');
  });
  
  $('#filter-3 .label_title').click(function(){
    $("#filter-3 ul").slideToggle();
    $("#filter-1 ul").slideUp();
    $("#filter-2 ul").slideUp();
    $("#filter-4 ul").slideUp();
    $("#filter-5 ul").slideUp();	
    $(this).toggleClass('on');
    $("#filter-1 .label_title").removeClass('on');
    $("#filter-2 .label_title").removeClass('on');
    $("#filter-4 .label_title").removeClass('on');
    $("#filter-5 .label_title").removeClass('on');
  });
  
  $('#filter-4 .label_title').click(function(){
    $("#filter-4 ul").slideToggle();
    $("#filter-1 ul").slideUp();
    $("#filter-2 ul").slideUp();
    $("#filter-3 ul").slideUp();
    $("#filter-5 ul").slideUp();
    $(this).toggleClass('on');
    $("#filter-1 .label_title").removeClass('on');
    $("#filter-3 .label_title").removeClass('on');
    $("#filter-2 .label_title").removeClass('on');
    $("#filter-5 .label_title").removeClass('on');
  });
    
  $('#filter-5 .label_title').click(function(){
    $("#filter-5 ul").slideToggle();
    $("#filter-1 ul").slideUp();
    $("#filter-2 ul").slideUp();
    $("#filter-4 ul").slideUp();
    $("#filter-3 ul").slideUp();	
    $(this).toggleClass('on');
    $("#filter-1 .label_title").removeClass('on');
    $("#filter-3 .label_title").removeClass('on');
    $("#filter-4 .label_title").removeClass('on');
    $("#filter-2 .label_title").removeClass('on');
  });
  
  setTimeout(function(){
  
 
    //$('.bc-sf-filter-block-content').css('display','none');
}, 1000);
 
  });

/*
$(window).on('load resize', function () {
  
var topheight = $(".new_header").height();
	$(".main-content").css({'padding-top': topheight});
  	$(".search-bar").css({'margin-top': topheight});
  
 var collheight = $(".small_collection_image").height();
 $(".collection-two-item .collection-grid-item__link").css({'height': collheight}); 
  
  
  
  
});*/
/*
$(window).scroll(function(){
        if($(window).scrollTop()  > 140) {
            $('.new_header').css('display','none');
          	$('.old_header').css('display','block');
          	$('.old_header').addClass('top-active');
          	$('.new_header').removeClass('top-active');
          	$('.search-bar').addClass('top-search');                    	
        }else{
            $('.new_header').css('display','block');
          	$('.old_header').css('display','none');
          	$('.old_header').removeClass('top-active');
          	$('.new_header').addClass('top-active');
          	$('.search-bar').removeClass('top-search');                    	
        }
    });
*/
/*
$(window).on('load resize', function () {
 
  var articleheight = $(".article_img").height();
  $(".article__info").css("height", articleheight);
  
  	var articleblog = $(".three_blog_box").height();
    $(".one_blog_box").css("height", articleblog);
  
  setTimeout(function(){
  	var articlebolg_box = $(".bolg_box").height();
  
  $(".one_blog_box .hero.boxs").css("height", articlebolg_box + articlebolg_box + 50);
}, 100);

    
  
});*/


  $(window).on('load resize', function () {
    
    var boxcol = $(".collection-large-img").height();
    
    
    $(".last_collection").css("height", boxcol);
    
     var topslideheight = $(".site-header").height();
   //alert(topslideheight);
     var slideheight = $(window).height();
    $(".index-section--slideshow .slideshow").css("height", slideheight - topslideheight - topslideheight);
    
   
    
    
		
	});